// Gestores (7-oct-2026): la pestaña «Gestión» de Analítica y los filtros de gestionados /
// propios / propietario de las pestañas Desempeño y Canales.
// Los textos con número llevan TRES tramos (1 / 2-4 / 5 y más): ver pluralizationRules en main.js.
export const gestionAnalytics = {
  tab: "Zarządzanie",
  tabRestricted: "Moje rozliczenie",
  restrictedTitle: "Moje rozliczenie",

  pageFilters: {
    ownership: "Obiekty",
    ownershipAll: "Zarządzane i własne",
    ownershipManaged: "Tylko zarządzane",
    ownershipOwn: "Tylko własne",
    owner: "Właściciel",
    allOwners: "Wszyscy właściciele",
  },

  views: {
    business: "Moja działalność",
    owners: "Właściciele",
    expenses: "Wydatki",
  },

  filters: {
    listings: "Obiekty",
    allListings: "Wszystkie",
    someListings: "{count} obiektów",
    owner: "Właściciel",
    allOwners: "Wszyscy",
    attribution: "Przypisanie rezerwacji",
    checkout: "Data wyjazdu",
    checkin: "Data przyjazdu",
    nights: "Noce w okresie",
    attributionHelp: "Według daty wyjazdu rozlicza się właścicieli: pobyt już się zakończył.",
    attributionHelpLabel: "Co oznacza „Przypisanie rezerwacji”",
    currency: "Waluta",
  },

  warnings: {
    otaEstimated:
      "{count} rezerwacja z prowizją OTA oszacowaną procentowo: kanał nie przekazał rzeczywistej. | {count} rezerwacje z prowizją OTA oszacowaną procentowo: kanał nie przekazał rzeczywistej. | {count} rezerwacji z prowizją OTA oszacowaną procentowo: kanał nie przekazał rzeczywistej.",
    noBreakdown:
      "{count} rezerwacja bez rozbicia: całą kwotę potraktowano jako zakwaterowanie. | {count} rezerwacje bez rozbicia: całą kwotę potraktowano jako zakwaterowanie. | {count} rezerwacji bez rozbicia: całą kwotę potraktowano jako zakwaterowanie.",
    outdatedBreakdown:
      "{count} rezerwacja została zmieniona lub przedłużona po imporcie: przyjęto jej aktualną kwotę. | {count} rezerwacje zostały zmienione lub przedłużone po imporcie: przyjęto ich aktualną kwotę. | {count} rezerwacji zostało zmienionych lub przedłużonych po imporcie: przyjęto ich aktualną kwotę.",
    otherCurrencies: "Są obiekty w innej walucie ({currencies}). Zmień ją powyżej, aby je zobaczyć.",
    noOwner:
      "{count} zarządzany obiekt nie ma przypisanego właściciela. | {count} zarządzane obiekty nie mają przypisanego właściciela. | {count} zarządzanych obiektów nie ma przypisanego właściciela.",
    assignOwners: "Przypisz właścicieli",
  },

  states: {
    loadError: "Nie udało się wczytać danych zarządzania.",
    forbidden: "Nie masz uprawnień do wyświetlania tych informacji.",
    periodTooLong: "Wybierz okres nie dłuższy niż dwa lata.",
    retry: "Spróbuj ponownie",
    noMovements: "Brak operacji w tym okresie",
  },

  empty: {
    title: "Zarządzasz obiektami innych właścicieli?",
    text: "Zaznacz w każdym obiekcie, że zarządzasz nim w imieniu właściciela, i określ warunki: swoją prowizję, kto pobiera płatności za rezerwacje i jak rozliczane jest sprzątanie. Tutaj zobaczysz, ile zarabiasz i co należy się każdemu właścicielowi.",
    point1: "Twoje prowizje, sprzątanie i wydatki – z rzeczywistym zyskiem",
    point2: "Ile przelać każdemu właścicielowi lub ile od niego pobrać",
    point3: "Rozliczenie każdego właściciela w PDF lub Excelu",
    cta: "Skonfiguruj moje obiekty",
  },

  period: {
    subtitle: "{period} · {attribution} · {granularity}",
    byCheckout: "rezerwacje według daty wyjazdu",
    byCheckin: "rezerwacje według daty przyjazdu",
    byNights: "noce w okresie",
    day: "dziennie",
    week: "tygodniowo",
    month: "miesięcznie",
  },

  counts: {
    reservations: "{count} rezerwacja | {count} rezerwacje | {count} rezerwacji",
    nights: "{count} noc | {count} noce | {count} nocy",
    units: "{count} obiekt | {count} obiekty | {count} obiektów",
    ownUnits: "{count} obiekt własny | {count} obiekty własne | {count} obiektów własnych",
    owners: "{count} właściciel | {count} właściciele | {count} właścicieli",
  },

  business: {
    kpi: {
      managedGross: "Przychód z zarządzanych",
      commissions: "Twoje prowizje",
      cleaning: "Sprzątanie",
      ownRevenue: "Przychód z obiektów własnych",
      expenses: "Wydatki",
      profit: "Zysk",
    },
    vatLine: "+ VAT {amount}",
    ofTotal: "całkowitego przychodu",
    overManaged: "przychodu z zarządzanych",
    ofIncome: "Twoich przychodów",
    margin: "marży",
    chartTitle: "Przychody, wydatki i zysk",
    chartA11y: "Wykres przychodów, wydatków i zysku w okresie",
    legend: {
      commissions: "Prowizje",
      cleaning: "Sprzątanie",
      own: "Obiekty własne",
      expenses: "Wydatki",
      profit: "Zysk",
    },
    byCategory: "Wydatki według kategorii",
    category: "Kategoria",
    amount: "Kwota",
    noExpenses: "Brak wydatków w tym okresie",
    seeExpenses: "Zobacz wydatki",
  },

  owners: {
    kpi: {
      gross: "Przychód z rezerwacji",
      ota: "Prowizje OTA",
      cleaning: "Sprzątanie",
      commission: "Twoja prowizja + VAT",
      commissionRestricted: "Prowizja zarządcy + VAT",
      charged: "Koszty obciążające właścicieli",
      net: "Netto dla właścicieli",
      netRestricted: "Twoje netto",
    },
    ofGross: "przychodu",
    collectedByYou: "pobierasz Ty",
    collectedByManager: "pobiera Twój zarządca",
    commissionLine: "{commission} + VAT {vat}",
    otaLine: "{commission} + VAT {vat}",
    otaTitle: "Prowizja OTA {commission} + VAT {vat}",
    commissionTitle: "Prowizja {commission} + VAT {vat}",
    toTransfer: "Do przelania właścicielom",
    toCollect: "Do pobrania od właścicieli",
    toTransferRestricted: "Twój zarządca przeleje Ci",
    toCollectRestricted: "Do zapłaty zarządcy",
    chartTitle: "Podział wpływów",
    chartA11y: "Wykres podziału przychodu z zarządzanych rezerwacji",
    legend: {
      net: "Netto właścicieli",
      netRestricted: "Twoje netto",
      commissions: "Twoje prowizje",
      commissionsRestricted: "Prowizja zarządcy",
      ota: "Prowizje OTA",
      cleaning: "Sprzątanie",
      other: "Opłaty, kaucje, VAT i koszty",
    },
    grossFooter: "Przychód: {amount}",
    tableTitle: "Rozliczenie według właścicieli",
    tableTitleRestricted: "Szczegóły Twojego rozliczenia",
    downloadAll: "Pobierz wszystko (PDF)",
    download: "Pobierz (PDF)",
    downloading: "Pobieranie…",
    pdf: "PDF",
    excel: "Excel",
    exportError: "Nie udało się pobrać rozliczenia.",
    cols: {
      owner: "Właściciel",
      reservations: "Rezerwacje",
      gross: "Przychód",
      ota: "OTA",
      cleaning: "Sprzątanie",
      commission: "Prowizja + VAT",
      charged: "Koszty",
      net: "Netto",
      balance: "Saldo",
      actions: "Pliki",
    },
    noOwner: "Bez przypisanego właściciela",
    transfer: "Do przelania {amount}",
    collect: "Do pobrania {amount}",
    receive: "Do otrzymania {amount}",
    pay: "Do zapłaty {amount}",
    collectionManager: "Pobiera zarządca",
    collectionOwner: "Pobiera właściciel",
    total: "Razem",
    expand: "Pokaż szczegóły: {name}",
    collapse: "Ukryj szczegóły: {name}",
    iban: "IBAN {iban}",
    showReservations: "Zobacz rezerwacje ({count})",
    hideReservations: "Ukryj rezerwacje",
    noData: "Brak zarządzanych rezerwacji w tym okresie.",
    reservations: {
      checkIn: "Przyjazd",
      checkOut: "Wyjazd",
      guest: "Gość",
      listing: "Obiekt",
      channel: "Kanał",
      gross: "Przychód",
      ota: "OTA",
      cleaning: "Sprzątanie",
      commission: "Prowizja",
      vat: "VAT",
      net: "Netto",
      direct: "Bezpośrednia",
      estimated: "szac.",
      estimatedHelp: "Oszacowana procentowo: kanał nie przekazał rzeczywistej prowizji.",
      noBreakdown: "bez rozbicia",
      noBreakdownHelp: "Rezerwacja nie ma rozbicia: całą kwotę potraktowano jako zakwaterowanie.",
      complete: "Complete",
      completed: "Completed",
      completeHelp: "Fill in cleaning, the real OTA commission or the cleaning for this booking",
      manual: "manual",
      manualHelp: "OTA commission entered by hand for this booking.",
      loading: "Wczytywanie rezerwacji…",
      loadError: "Nie udało się wczytać rezerwacji.",
      empty: "Brak rezerwacji w tym okresie.",
    },
    charged: {
      title: "Koszty obciążające właściciela",
      date: "Data",
      concept: "Opis",
      listing: "Obiekt",
      amount: "Kwota",
      general: "Ogólne",
    },
  },

  a11y: {
    views: "Sekcje zarządzania",
  },
  // Liquidación por propietario: la cuenta y las columnas del PDF.
  liq: {
    precio: "Cena",
    comision: "Prowizja OTA",
    tasas: "Opłaty",
    limpieza: "Sprzątanie",
    honorarios: "Wynagrodzenie",
    honorariosIva: "Wynagrodzenie + VAT",
    neto: "Netto właściciela",
    transfieres: "Przelewasz",
    tePaga: "Płaci Ci",
    recibes: "Otrzymujesz",
    pagas: "Płacisz",
    netoPropietarios: "Netto dla właścicieli",
    formula: "Przychód = Cena − Prowizja · Razem = Przychód − Opłaty − Sprzątanie · Netto = Razem − Wynagrodzenie − VAT. Tak jak w PDF i Excelu.",
    cols: {
      origen: "Źródło",
      nombre: "Imię",
      entrada: "Przyjazd",
      salida: "Wyjazd",
      precio: "Cena",
      noches: "Noce",
      comision: "Prowizja",
      ingreso: "Przychód",
      tasas: "Opłaty",
      limpieza: "Sprzątanie",
      total: "Razem",
      honorarios: "Wynagrodzenie",
      iva: "VAT",
      neto: "Netto",
    },
  },
};
